import React, { Component } from 'react';
import Slider from 'react-slick';
import { inject } from 'mobx-react';
import { ArtworkComponent } from '../_artwork/artwork.component';

import '../_artwork/artwork.scss';

@inject('appStore', 'routerStore')
export class CollectionCarousel extends Component {

    slider;

    componentDidUpdate() {
        const { currentSlide, sliderOpen } = this.props;
        if (sliderOpen) {
            setTimeout(() => {
                this.slider.slickGoTo(currentSlide, false);
            }, 200);
        }

        if (sliderOpen) {
            document.body.classList.add('artwork-open');
        } else {
            document.body.classList.remove('artwork-open');
        }
    }

    afterChange(index) {
        const { collection, routerStore } = this.props,
            artwork = collection.Artwork[index];

        // ensure all content is scrollTop 0
        let elements = document.getElementsByClassName('artwork-content');
        if (elements.length) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].scrollTop = 0;
            }
        }

        // change url if required
        if (artwork && routerStore.location.pathname !== artwork.Link) {
            routerStore.history.push(artwork.Link);
        }
    }

    render() {
        const { collection } = this.props,
            settings = {
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                afterChange: (index) => this.afterChange(index)
            };

        return <div>
            {collection && collection.Artwork.length && <Slider ref={c => { this.slider = c; }} {...settings}>
                {collection.Artwork.map((artwork, i) => {
                    return <ArtworkComponent key={artwork.ID} artwork={artwork} index={1} collection={collection} />;
                })}
            </Slider>}
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_collection/collection.carousel.js